import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  primaryActionModal: () => i18n.t(i18nKeys.action__gotIt),
  insuranceCertificationLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__insuranceCertificationLabel),
  terms: () => i18n.t(i18nKeys.insuranceCheckbox__terms),
  termsLabel: () => i18n.t(i18nKeys.insuranceCheckbox__termsLabel),
  termsTitle: () => i18n.t(i18nKeys.insuranceCheckbox__termsTitle),
}
